var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAutomotive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.951,
    height: 29.951,
    viewBox: "0 0 29.951 29.951",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.976,1A14.976,14.976,0,1,0,30.951,15.976,14.992,14.992,0,0,0,15.976,1ZM29.383,11.914l-5.237,3.223a8.181,8.181,0,0,0-2.257-4.847l1.629-6.111a14.065,14.065,0,0,1,5.865,7.735ZM15.976,23.222a7.246,7.246,0,1,1,7.246-7.246,7.254,7.254,0,0,1-7.246,7.246Zm6.68-19.558L21.084,9.557a8.164,8.164,0,0,0-4.83-1.78L12.891,2.313a13.964,13.964,0,0,1,9.765,1.352Zm-10.741-1.1,3.223,5.237a8.181,8.181,0,0,0-4.847,2.257L4.179,8.434a14.065,14.065,0,0,1,7.735-5.865ZM3.664,9.3l5.893,1.571a8.164,8.164,0,0,0-1.78,4.83L2.313,19.06A13.964,13.964,0,0,1,3.664,9.3Zm-1.1,10.741,5.237-3.223a8.181,8.181,0,0,0,2.257,4.847L8.434,27.772a14.065,14.065,0,0,1-5.865-7.735ZM9.3,28.287l1.571-5.893a8.164,8.164,0,0,0,4.83,1.78l3.363,5.465A13.962,13.962,0,0,1,9.3,28.287Zm10.741,1.1-3.223-5.237a8.181,8.181,0,0,0,4.847-2.257l6.111,1.629a14.065,14.065,0,0,1-7.735,5.865Zm8.25-6.727-5.893-1.571a8.164,8.164,0,0,0,1.78-4.83l5.465-3.363a13.962,13.962,0,0,1-1.352,9.764Z",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.348,23A4.348,4.348,0,1,0,31.7,27.348,4.352,4.352,0,0,0,27.348,23Zm0,7.729a3.382,3.382,0,1,1,3.382-3.382A3.386,3.386,0,0,1,27.348,30.729Z",
    transform: "translate(-11.372 -11.372)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.415,27a2.415,2.415,0,1,0,2.415,2.415A2.418,2.418,0,0,0,29.415,27Zm0,3.865a1.449,1.449,0,1,1,1.449-1.449A1.451,1.451,0,0,1,29.415,30.865Z",
    transform: "translate(-13.44 -13.44)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,43h.966v.966H31Z",
    transform: "translate(-15.507 -21.71)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,19h.966v.966H31Z",
    transform: "translate(-15.507 -9.304)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,31h.966v.966H19Z",
    transform: "translate(-9.304 -15.507)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,31h.966v.966H43Z",
    transform: "translate(-21.71 -15.507)",
    fill: "#0080ff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomotive);
export default __webpack_public_path__ + "static/media/automotive.e6a00714.svg";
export { ForwardRef as ReactComponent };